export default function InfoUser({
  objectData,
  title,
  more_address_data = true,
}) {
  return (
    <div className="info-user ">
      <div className="title text-center  fw-bold" style={{ fontSize: 13 }}>
        {title}
      </div>
      <div className=" ps-2 py-1">
        <div className="d-flex justify-content-between">
          <p className="col-6 values">
            نام شخصی حقیقی / حقوقی : {objectData?.title}
          </p>
          <p className="col-3 values">
            شماره اقتصادی : {objectData?.economical_number}
          </p>
          <p className="col-3 values">
            شماره ثبت / شماره ملی: {objectData?.identification_code}
          </p>
        </div>
        <div className="d-flex justify-content-between">
          {more_address_data && (
            <p className="col-3 values">
              نشانی کامل: استان: {objectData?.province}
            </p>
          )}
          {more_address_data && (
            <p className="col-3 values">شهرستان : {objectData?.township}</p>
          )}
          {more_address_data ? (
            <p className="col-3 values">
              کدپستی 10 رقمی: {objectData?.postalCode}
            </p>
          ) : (
            <p className="col-9 values">نشانی : {objectData?.custom_address}</p>
          )}
          {more_address_data && (
            <p className="col-3 values">شهر: {objectData?.city}</p>
          )}
        </div>
        <div className="d-flex justify-content-between">
          {more_address_data ? (
            <p className="col-9 values">نشانی : {objectData?.custom_address}</p>
          ) : (
            <p className="col-3 values">
              کدپستی 10 رقمی: {objectData?.postalCode}
            </p>
          )}
          <p className="col-3 values">شماره تلفن/ نمابر : {objectData?.tell}</p>
        </div>
      </div>
    </div>
  );
}
